export default "__VITE_ASSET__zN3GnWb5__"